<template>
    <div id="app">
        <LanguageChanger class="language"/>
        <router-view />
    </div>
</template>

<script>
import LanguageChanger from './components/systems/elements/LanguageChanger.vue'

export default {
    name: 'App',
    components: {
        LanguageChanger
    }
}
</script>

<style scoped>
.language {
    position: absolute;
    margin: 10px;
    left: 0;
    right: 0;
}
</style>

<style>
@import './assets/css/application.css';
</style>
